import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function SchoolTiming() {
    useEffect(() => {
        document.title = 'Sports -  CARMEL CONVENT SCHOOL, DHARUHERA';
    }, []);
    return (
        <>
            <Header />
            <div className="sliderbg"></div>
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ul className="breadcrumbli">
                                <li><Link to="/"> Home </Link></li>
                                <li>Academics</li>
                                <li>School Timing</li>
                            </ul>
                        </div>
                        <div className="col-lg-12">
                            <h2 className="innerheading">  School Timing</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-12'>
                            <div className="d-flex">
                                <div>
                                    <p>
                                        {" "}
                                        Summer <span>7:45 AM to 1:15 PM</span>
                                        <br />
                                        Winter <span>8:30 AM to 2:00 PM</span>
                                    </p>
                                    <p>

                                    </p>
                                </div>
                            </div>
                            <h5>Office Timings</h5>
                            <div className="d-flex">
                                <div>
                                    <p>
                                        Monday to Friday <span>9:00 AM to 12:00 AM</span> (Except
                                        Govt. Holidays)
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div className='col-12'>
                            <h5>SCHOOL  OFFICE  HOURS</h5>
                            <p>The Office will remain open on all working days from 8:00 a.m. to 3:00 p.m. but public dealings will be from 8:00 am. to 11:00 am. only. </p>
                            <h5><b>Note to Parents</b></h5>
                            <ul className="mainlist">
                                <li> Parents of Classes Nur. to 6th students, will meet their respective teachers on the days fixed for PTM (Parents-Teachers Meet) as given in the School Diary.</li>
                                <li> Parents and guardians are not allowed to see their children or interview teachers during school hours without the permission of the Principal. Parents and guardians are requested not to call their children and class teachers on telephone during class hours.</li>
                                <li> Parents are particularly expected to sign the principal's or Teacher's remarks. Failure to do this may put their children to great inconvenience.</li>
                                <li>Parents are earnestly requested to enforce regularity and discipline at home and see that their children prepare their lessons and do the assigned home work. The diary should be checked daily.</li>
                                <li>Criticism of a student's teacher or school in his/her presence should be strictly avoided, because it causes the student to lose his/her respect for the teacher with consequent failure to learn from her. Should you have a legitimate complaint, meet the principal personally.</li>
                                <li> Withdrawal of your child from classes for mere social functions is not permitted, because it retards the child's progress in the school and minimizes his/her interest for regular hard work with consequent failure to progress in studies.</li>
                                <li> Students failing to appear in test will be marked absent, no retest will be taken.</li>
                                <li> On no account should a teacher be engaged to give tuition to a child of the same school.</li>
                                <li> Birthday gifts and gift-packets are strictly forbidden to be distributed to the classmates and teachers of your ward.</li>
                                <li> As the medium of instruction in the school is English, children should be helped 	to follow their classes easily and intelligently by a certain amount of English 	conversation at home.</li>
                                <li>  Parents will apply in writing if children are required at home during school hours and 	children will be allowed to go home only if accompanied by parents and only in 	emergency situations.</li>
                            </ul>
                            <h5>PARENTS, PLEASE.........</h5>
                            <ul className="mainlist">
                                <li>Send your children smartly dressed to school. Many are the cases when the clothings of the children are checked and are found to be dirty specially, stockings, slips etc. Your child should not be one among them.</li>
                                <li> See that the children have daily bath, every part of their body clean, hair combed.</li>
                                <li> See that your children are in complete uniform and reach the school well on time.</li>
                                <li>  Once the child comes to the school, she/he will not be allowed to leave the school before the school gets over. Hence requests for half-day leave, short leave etc. will not be entertained.</li>
                                <li>The school will not accept books, Tiffin or other articles needed for your child during school timings.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default SchoolTiming